import { render, staticRenderFns } from "./appModelView.vue?vue&type=template&id=b4228afc"
import script from "./appModelView.vue?vue&type=script&lang=js"
export * from "./appModelView.vue?vue&type=script&lang=js"
import style0 from "./appModelView.vue?vue&type=style&index=0&id=b4228afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports